import { Dialog } from "@material-ui/core";
import { CalendarEvent } from "../../../@types/sharedSchema";
import { CalendarForm } from "components/_dashboard/calendar";
import type { DialogProps } from "@material-ui/core/Dialog";
import type { CalendarContextProps } from "../../../@types/calendar";

type Props = DialogProps & {
  event: CalendarEvent;
  createOrUpdateEvent: CalendarContextProps["createOrUpdateEvent"];
  deleteEvent: CalendarContextProps["deleteEvent"];
};

export const CalendarEventDialog: React.FC<Props> = ({
  open,
  event,
  onClose,
  deleteEvent,
  createOrUpdateEvent,
  ...props
}) => {
  return (
    <Dialog {...props} open={open} maxWidth="md" fullWidth={true} onClose={onClose}>
      <CalendarForm
        event={event}
        onCancel={onClose as VoidFunction}
        onUpdate={createOrUpdateEvent}
        onDelete={deleteEvent}
      />
    </Dialog>
  );
};
